// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Callout-module--bx--text-truncate--end--2LzCK";
export var bxTextTruncateFront = "Callout-module--bx--text-truncate--front--2nosp";
export var firstColumn = "Callout-module--firstColumn--HZAdE";
export var grid = "Callout-module--grid--3kn8R";
export var row = "Callout-module--row--3Y1Bt";
export var secondColumn = "Callout-module--secondColumn--1Dk4o";